import HomePage from './HomePage.container'

export default HomePage
